import { Button, Menu, MenuDivider, MenuItem } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import { LanguageSelector } from "./LanguageSelector";

interface SettingsProps {
  set_dark_mode: (f: boolean) => void;
  is_dark_mode: boolean;
}

export const Settings = (props: SettingsProps) => (
  <Popover2
    position="bottom-right"
    content={
      <Menu>
        <MenuItem
          href="https://git.ccmob.net/radium"
          text="Gitlab"
          icon="code"
          target="_blank"
        />
        <MenuDivider />
        <LanguageSelector />
        <MenuItem
          text={props.is_dark_mode ? "Light Mode" : "Dark Mode"}
          onClick={() => props.set_dark_mode(!props.is_dark_mode)}
        />
      </Menu>
    }
  >
    <Button icon="menu" />
  </Popover2>
);
